import { useEffect } from 'react';
import { useServices } from 'core/common/hooks';
import {
  useThreeDomainSecurePayment,
  useThreeDomainSecurePaymentListener,
} from 'core/payments/hooks';

type Params = {
  onSucceed?: () => void;
};

export const usePaymentThreeDomainSecure = ({ onSucceed }: Params) => {
  const { analyticsService } = useServices();

  const { paymentProcessingData, paymentFormFailed, paymentFormSucceed } =
    useThreeDomainSecurePayment();

  const paymentSucceed = () => {
    analyticsService.trackEvent('three_domain_secure_succeed');

    if (onSucceed) {
      onSucceed();
    }

    paymentFormSucceed();
  };

  const paymentFailed = () => {
    analyticsService.trackEvent('three_domain_secure_failed');

    paymentFormFailed();
  };

  useThreeDomainSecurePaymentListener({ paymentSucceed, paymentFailed });

  useEffect(() => {
    analyticsService.trackEvent('three_domain_secure_opened');
  }, [analyticsService]);

  return {
    paymentProcessingData,
  };
};
